// extracted by mini-css-extract-plugin
module.exports = {"scaledPhotoFunImage":"idt-croptool_scaledphotofunimage__1g2nk","children":"idt-croptool_children__22nrt","animate":"idt-croptool_animate__3b5li"};